import Panel            from './panel';
import PanelCorner      from './panelCorner';

export {
  Panel,
  PanelCorner
}



// WEBPACK FOOTER //
// ./src/components/panel/index.js